'use client';
import classNames from 'classnames';
import Link from 'next/link';
import { AnchorHTMLAttributes, ReactElement } from 'react';

// NOTE: You can pass an onClick handler (added to the child anchor) - see
// https://github.com/vercel/next.js/pull/4474

interface LinkedButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /**
   * Additional text
   */
  description?: string;
  /**
   * Navigation path
   */
  href: string;
  /**
   * Size in relation to container
   */
  size: 'full-width' | 'half-width' | 'quarter-width';
  /**
   * Main text
   */
  title: string;
  /**
   * Styling variant
   */
  variant: 'filled' | 'outlined' | 'underlined';
}

/**
 * Button-style link component.
 *
 * Only use this for internal routing - see
 * https://github.com/vercel/next.js/blob/master/errors/invalid-href-passed.md
 */
const LinkedButton = (props: LinkedButtonProps): ReactElement => {
  const { description, href, size, title, variant, ...rest } = props;

  return (
    <Link href={href} passHref {...rest} className={classNames(variant, size)}>
      <span {...rest} className={classNames(variant, size)}>
        {title}
        {description && <span>{description}</span>}
      </span>
    </Link>
  );
};

export default LinkedButton;
